import * as React from 'react';
import SvgTable from '../../../svg-components/Table';
import { zVar } from '../../../ui/theme';

/*
 * TableBackground — the felt poker-table SVG as a single background layer that
 * fills the Stage. Replaces the old DivContainer{SvgTable} bottom layer. Kept
 * SVG asset; just re-homed into a positioned DOM node.
 */

export const TableBackground: React.FC = () => (
  <div
    style={{
      position: 'absolute',
      inset: 0,
      zIndex: zVar('z-table'),
      pointerEvents: 'none',
    }}
  >
    <SvgTable
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid meet"
      style={{ display: 'block' }}
    />
  </div>
);

export default TableBackground;
